"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootHeader: {
    alignItems: 'center',
    backgroundColor: _theme.default.palette.primary.main,
    boxShadow: "0px 2px 4px ".concat(_theme.default.palette.primary.headerShadow),
    [_theme.default.breakpoints.up('lg')]: {
      boxShadow: 'none'
    }
  },
  headerContainer: {
    boxSizing: 'border-box',
    width: '100%',
    [_theme.default.breakpoints.up('xs')]: {
      minHeight: '60px',
      paddingLeft: '20px',
      paddingRight: '20px',
      fontSize: '14px'
    },
    [_theme.default.breakpoints.up('md')]: {
      paddingLeft: '50px',
      paddingRight: '50px',
      fontSize: '14px'
    },
    [_theme.default.breakpoints.up('lg')]: {
      paddingLeft: '50px',
      paddingRight: '50px',
      fontSize: '14px'
    },
    [_theme.default.breakpoints.up('xl')]: {
      paddingLeft: '36px',
      paddingRight: '36px',
      fontSize: '16px'
    }
  }
});
var _default = exports.default = useStyles;